import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragIndicator } from '@mui/icons-material';
import { Card } from '@mui/material';
import type { JSONContent } from '@tiptap/react';
import RichContent from '@/components/shared/rich-content';

export default function SortableItem({ id, content }: { id: string; content: JSONContent }) {
  const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({
    id,
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={{
        ...style,
        touchAction: 'none', // Better for dragging on mobile
      }}
      {...attributes}
      {...listeners}>
      <Card
        variant="outlined"
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'move',
          padding: '10px 8px',
          marginBottom: (theme) => theme.spacing(1),
          color: (theme) => (isDragging ? theme.palette.primary.main : theme.palette.text.primary),
          borderColor: (theme) =>
            isDragging ? theme.palette.primary.main : theme.palette.text.primary,
        }}>
        <DragIndicator sx={{ mr: 1 }} />
        <RichContent content={content} noParagraphMargin />
      </Card>
    </div>
  );
}
